import { render, staticRenderFns } from "./record_buy.vue?vue&type=template&id=12c3cf4e&scoped=true"
import script from "./record_buy.vue?vue&type=script&lang=js"
export * from "./record_buy.vue?vue&type=script&lang=js"
import style0 from "./record_buy.vue?vue&type=style&index=0&id=12c3cf4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3cf4e",
  null
  
)

export default component.exports